
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giftcard/[giftcardName]",
      function () {
        return require("private-next-pages/giftcard/[giftcardName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giftcard/[giftcardName]"])
      });
    }
  